module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "item__title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', {
    staticClass: "item__value",
    class: _vm.color
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22dd14eb","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/certificate/components/score/components/item/Item.vue
// module id = 643a200cc50a742e4bd6
// module chunks = 9